module.exports = __webpack_public_path__ + "img/slide-4.44d87aeb.jpg";